export default __webpack_public_path__ + "static/media/abb-smarter-mobility.4f82e1d3.webp";